// This file is auto-generated.
export default {
    "version": "4.8.13",
    "buildDate": "2026-09-15 16:18:49",
    "buildPlatform": "vega",
    "buildBrandId": "cbs-sports",
    "buildBundle": false,
    "buildEnv": "prod",
    "gql": {
        "endpoint": "https://helios-prod.cbssports.cloud"
    },
    "api": {
        "apiUrl": "https://video-api.cbssports.com/",
        "platformQuery": "firetv",
        "diffFetchInterval": 15000,
        "shortCodeInterval": 10000,
        "maxRetryFallbackMs": 600000,
        "apiKey": "lyR2U37Sie80c02cJMpOH4C3gJety4LO1WnLA1FO",
        "apiPath": "vms",
        "geoApiUrl": "https://video-api-compute.cbssports.com/v2/dma.json",
        "rotatingSegmentTitlesApiUrl": "https://video-assets.cbssports.com/events/segment-title/v1.json",
        "logoUrlBase": "https://ottimg.cbssports.com/",
        "menuQuery": "3"
    },
    "log": {
        "enabled": false,
        "minLevel": 0
    },
    "analytics": {
        "utagUrl": {
            "env": "prod",
            "platformPath": "cbssports-vega"
        },
        "fields": {
            "pageNameBase": "cbssports/vega/",
            "siteHierBase": "cbssports|vega|"
        }
    },
    "textToSpeech": {
        "allCapsTextToSplit": [
            "CBS"
        ],
        "dotTextToIgnore": []
    },
    "contactEmail": "cbssports-vega@cbsinteractive.com",
    "playback": {
        "idleToFullScreenMs": 8000,
        "idleToFullScreenWithActivityMs": 20000,
        "nowPlayingMsgDurationMs": 8000,
        "upNextMsgBeforeVideoEndMs": 8000,
        "ima": {
            "appName": "cbs sports",
            "bundle": "cbs sports",
            "descriptionUrl": "https://www.cbssports.com/live/",
            "url": "cbs sports",
            "appId": "cbssports.vega",
            "iu": "/8264/vaw-sports/ott/cbssports_vega_tv_app",
            "csid": "vcbs_cbssports_us_ctv_vega_live"
        },
        "drm": {
            "aes": {
                "provider": "irdeto.com"
            }
        },
        "debug": false
    },
    "featureFlags": {
        "enableParamountPlus": true
    },
    "ksDeviceType": "vega",
    "areYouStillWatching": {
        "noResponseTimeoutMs": 60000
    },
    "idleMode": {
        "idleTimeoutMs": 900000
    },
    "network": {
        "intervalDelay": 10000
    },
    "isDebug": false,
    "platformName": "vega",
    "subdomain": "ctv-vega",
    "fmsBundle": "cbssports.vega",
    "privacy": {
        "organization": "cbs_sports",
        "property": "cbs_sports_amazon_vega"
    },
    "geoApiKey": "DiqWDIvQysKjaKqYKaELunHC5kV30DX5",
    "brand": {
        "id": "cbs-sports",
        "name": "CBS Sports",
        "appId": "com.cbssports.app.ps4",
        "hostedDomain": "cbssports.com",
        "defaultNetworkName": "CBS Sports HQ",
        "preGameDescription": "the latest sports news, highlights, and analysis",
        "eventType": "game",
        "colors": {
            "default": 16410885,
            "splashSpinner": 16316664
        }
    },
    "appId": "com.cbssports.app.ps4",
    "appName": "CBS Sports"
};
